module.exports = __webpack_public_path__ + "img/profile_box_gray_height.5505ffff.svg";